// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__JIXmf","tabs-wrap":"Tabs_tabs-wrap__qpmPV"};